<div class="payment-form-warning" *ngIf="this.expireInfo && this.expireInfo?.exp_info != null">
  {{ this.expireInfo.exp_info }}
</div>
<div class="expire-loader" *ngIf="expireInfoLoading">
  <app-advanced-loader></app-advanced-loader>
</div>

<div class="payment-form-container">
	<form [formGroup]="form" (ngSubmit)="submitForm()">

		<div class="form-group">
			<label>Имя</label>
			<input type="text" formControlName="firstName" placeholder="Иван" [attr.disabled]="trafficPack.loading ? true : null">
		</div>

		<div class="form-group">
			<label>Фамилия</label>
			<input type="text" formControlName="lastName" placeholder="Иванов" [attr.disabled]="trafficPack.loading ? true : null">
		</div>

		<div class="form-group">
			<label>E-mail</label>
			<input type="email" formControlName="email" placeholder="mail@example.ru" [attr.disabled]="trafficPack.loading ? true : null">
		</div>

		<div class="buttons-wrapper">
			<button type="submit" [attr.disabled]="trafficPack.loading ? true : null">Оплатить</button>
		</div>

	</form>
</div>

<div class="form-loader" *ngIf="trafficPack.loading">
  <app-advanced-loader></app-advanced-loader>
</div>
